<template>
  <div>
    <div class="row">
      <div class="col-xxl-12">
        <RulesTable
          :list="list"
          :count="count"
          :status="status"
          :title="`<span class='card-label font-weight-bolder text-dark'> Rules</span>
              <span class='text-muted mt-3 font-weight-bold font-size-sm'>
                  Total count: ${count}
              </span>`"
        >
          <rules-filter />
        </RulesTable>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";

import { requestStatus, buildFilterString } from "@/core/services/services";
import * as TYPES from "@/core/services/store/modules/rules/types";
import * as PAGE_TYPES from "@/core/services/store/modules/page/types";

import RulesTable from "./components/RulesTable";
import RulesFilter from "./components/RulesFilter";

export default {
  name: "Rules",
  components: {
    RulesTable,
    RulesFilter,
  },
  computed: {
    ...mapState({
      list: (state) => state.rules.list,
      count: (state) => state.rules.count,
      status: (state) => state.rules.status,
      filter: (state) => state.page.filter,
    }),
  },
  methods: {
    ...mapActions({
      loadDataAction: `rules/${TYPES.GET_RULES}`,
    }),
    ...mapMutations({
      setFilter: `page/${PAGE_TYPES.SET_PAGE}`,
      changeFilter: `page/${PAGE_TYPES.CHANGE_FILTER}`,
    }),

    loadData: function (filter) {
      this.loadDataAction(buildFilterString(filter));
    },
  },
  watch: {
    status(newValue) {
      if (
        (newValue.change_field === "edit" &&
          newValue.edit === requestStatus.success) ||
        (newValue.change_field === "bulk_edit" &&
          newValue.bulk_edit === requestStatus.success)
      ) {
        this.loadData(this.filter);
      }
    },
    filter(newValue) {
      this.loadData(newValue);
    },
  },
  created: function () {
    window.getApp.$on("GET_RULES_EVENT", () => {
      this.loadData(this.filter);
    });
    this.loadData(this.filter);
  },
};
</script>
